import React from "react";
import { component_tool } from '@/tool';
import { WizClassifySelect, WizAuthority, WizTableForm,WizDataAuthSelect } from '@/containers/common'
import moment from "moment";
import HighSet from "@/containers/common/highSet";
import QRCode from 'qrcode.react';

const examTempConfig = WizTableForm.Config.examTemp(this, { apiParams: { state: 1 } });
let { WizModal, WizButton } = component_tool;

/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-04
 */
let componentName = 'exam'
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = (data) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '考试名称',
      name: 'title',
      searchItem: {}
    },
    {
      title: '考试分类',
      name: 'categoryTypeIds',
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          itemProps: {
            icon: 'unordered-list',
            title: '考试分类',
            tips: '请选择考试分类'
          },
          treeProps: { checkStrictly: true },
          checkable: false
        },
        apiProps: { type: 0 },
        selectProps: {
          placeholder: '请选择考试分类'
        },
      }
    },
    {
      title: '考试状态',
      name: 'status',
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已关闭' }
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '考试名称',
      name: 'title',
      tableItem: {
        width: 200
      }
    },
    {
      title: '考试分类',
      name: 'categoryType',
      tableItem: {}
    },
    {
      title: '考试类型',
      name: 'examType',
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '独立考试' },
        { code: 1, codeName: '课程考试' },
      ]
    },
    // {
    //   title: '考试受众',
    //   name: 'targetScope',
    //   tableItem: {
    //     render: (text, record) => {
    //       return <WizAuthority value={record.targetScope} mode='Button' />
    //     }
    //   }

    // },
    {
      title: '开始时间',
      name: 'startDate',
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '结束时间',
      name: 'endDate',
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '状态',
      name: 'status',
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已关闭' }
      ],
      tableItem: {}
    },
    {
      title: '身份验证',
      name: 'face',
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {},
    }
  ]
};

this._downQrCode = () => {
  const canvasImg = document.getElementById('qrCode'); // 获取canvas类型的二维码
  const img = new Image();
  img.src = canvasImg.toDataURL('image/png'); // 将canvas对象转换为图片的data url
  let a_link = document.getElementById('down_link');
  a_link.href = img.src
  a_link.download = '考试二维码';
};


const templateConfig = (data) => {
  const { self } = data;
  let valueRows = []
  let tableFormProps = {
    title: '选择考试模版',
    showModal: false,
    initApiSearch: true,
    showSelectValue: true,
    visible: true,
    selectType: 'radio',
    initRows: [],
    value: [],
    onSubmit: self._addExamByTempSubmit,
    onCancel: self._onCancel,
  }

  const _renderBtn = (value, valueRowList) => {

    if (value && value > 0) {
      value = value[0]
    }
    valueRows = valueRowList
  }
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params:
      {
        columns: columns(data),
        searchBarProps:
        {
          buttonSort: ['group', 'export'],
          buttons:
            [
              {
                type: 'group',
                key: 'group',
                params: {
                  key: '_group_btn',
                  icon: 'down', children: '新增', type: 'primary',
                },
                options: [
                  {
                    key: 'createFromTemplate',
                    custom: true,
                    params: {
                      children: '从模版创建'
                    },

                    customOnClick: {
                      key: "modal",
                      params: {
                        modalParams: {
                          title: "选择考试模版",

                          diy: (e) => {
                            return <WizTableForm key={new Date().getTime()}  {...examTempConfig}  {...tableFormProps} renderValue={_renderBtn} />
                          },
                          onOk: (obj, e) => {
                            self._addExamByTempSubmit({ valueRows: valueRows })
                          },
                          width: 700
                        }
                      }
                    }
                  },
                  {
                    key: 'add',
                    custom: true,
                    params: { icon: 'plus', children: '新增', type: 'primary' },
                    customOnClick: {
                      key: 'jumpPage',
                      params: {
                        key: 'push',
                        pathname: '/online/exam/examDetailAdd'
                      }
                    }
                  }
                ]
              },
              {
                key: 'export',
                custom: true,
                params: { icon: 'export', children: '导出', type: 'export' },
                customOnClick: {
                  key: 'action',
                  params: {
                    apiKey: "export",
                    apiParams: {}
                  },
                  formatParams: (rows, record, filters, callback) => {
                    return { ...filters }
                  }
                }
              }
            ]
        }
        ,
        rowOperateSort: ['look', 'update', 'examPreview', 'release', 'close', 'delete', 'QRCode', 'resultsView', 'markThePapers', 'copyExam', 'openAuthentication', 'closeAuthentication', 'downloadExamRank', 'advancedSet','authSetting'],//英文
        rowOperateView:
          [
            {
              key: "QRCode",
              custom: true,
              params: { children: "考试二维码" },
              customOnClick: {
                key: 'modal',
                params: {
                  modalParams: {
                    title: '考试二维码',
                    footer: null,
                    destroyOnClose: true,
                    diy: (e) => {
                      return <>
                        <h2 align="center">{e.record.title}</h2>
                        <div align='center' style={{ paddingBottom: 20 }}>
                          <QRCode
                            style={{ margin: 20 }}
                            id="qrCode"
                            value={constants.env.sys_get_app_link(`sgmlms://sgmlms/examDetail/${e.record.id}/true`)}
                            fgColor="#000000" // 二维码的颜色
                          />
                          <br />
                          <a style={{ borderRadius: 3, borderWidth: 1, borderStyle: 'solid', borderColor: '#6faff8', padding: 8 }} id='down_link' onClick={this._downQrCode}>下载二维码</a>
                        </div>
                      </>
                    }
                  }
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let disabled = false
                if (record && record['status'] !== 1) {
                  disabled = true
                }
                return { disabled }
              }
            },
            {
              key: 'resultsView',//成绩查看
              custom: true,
              params: { children: '成绩查看' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/online/exam/examGradeInfo'
                }
              }
            },
            {
              key: "markThePapers",
              custom: true,
              params: { children: "批改试卷", disabled: true },
              customOnClick: {
                key: "action",
                params: {}
              }
            },
            {
              key: "openAuthentication",
              custom: true,
              params: { children: "开启身份验证", disabled: true },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: 'changeExamFaceAuth'
                },
                formatParams: (rows, record, filters, callback) => {
                  let {doingAuth,authenticationCount,spaceTime,limitMinutes} = record;
                  let content = '您正在开启身份验证，学员考试时将进行考前验证，是否确认？';
                  if (doingAuth!==null && doingAuth!==-1 && doingAuth!==undefined){
                    //是否支持考试中认证{0:否,1:是}
                    if (doingAuth===1){
                      if (limitMinutes==null || spaceTime==null || limitMinutes<spaceTime){
                        content = '无法开启身份验证，考中验证的“间隔时间”需大于考试时长，请确认后重试!';
                        WizModal.confirm({
                          title: '注意', content,
                          onOk: () => {
                          },
                          onCancel() {
                          }
                        });
                      }else {
                        content = '您正在开启身份验证，学员考试时将进行考前验证和考中验证，考中验证进行'+authenticationCount+'次，间隔'+spaceTime+'分钟，是否确认？';
                        WizModal.confirm({
                          title: '注意', content,
                          onOk: () => {
                            callback && callback({
                              ids: [record.id],
                              face: 1
                            })
                          },
                          onCancel() {
                          }
                        });
                      }
                    }else {
                      WizModal.confirm({
                        title: '注意', content,
                        onOk: () => {
                          callback && callback({
                            ids: [record.id],
                            face: 1
                          })
                        },
                        onCancel() {
                        }
                      });
                    }
                  }else {
                    WizModal.confirm({
                      title: '注意', content,
                      onOk: () => {
                        callback && callback({
                          ids: [record.id],
                          face: 1
                        })
                      },
                      onCancel() {
                      }
                    });
                  }

                  return null
                },
              },
              recordChangeParams: ({ record, rows }) => {
                let {examType,status,face,categoryType} = record;
                let disabled = true;
                let hidden = true;
                //是否身份验证{0:否,1:是}
                if (status === 0 && '普通考试'===categoryType && examType===0 && face===0){
                  disabled =false;
                  hidden = false;
                }
                return { disabled: disabled, hidden: hidden }
              },
            },
            {
              key: "closeAuthentication",
              custom: true,
              params: { children: "关闭身份验证", disabled: true },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: 'changeExamFaceAuth'
                },
                formatParams: (rows, record, filters, callback) => {
                  const content = '您正在关闭身份验证，学员考试时将不进行身份验证，是否确认？'
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids: [record.id],
                        face: 0
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                },
              },
              recordChangeParams: ({ record, rows }) => {
                let {examType,status,face,categoryType} = record;
                let disabled = true;
                let hidden = true;
                //是否身份验证{0:否,1:是}
                if (status === 0 && '普通考试'===categoryType && examType===0 && face===1){
                  disabled =false;
                  hidden = false;
                }
                return { disabled: disabled, hidden: hidden }
              },
            },
            {
              key: 'copyExam',
              custom: true,
              params: { children: '复制考试' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/online/exam/examDetailAdd',
                  record: { copyExam: 1 }
                }
              }
            },
            {
              key: 'release',
              custom: true,
              params: { children: '发布' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'publish'
                },
                formatParams: (rows, record, filters, callback) => {
                  const content = '您确定要发布该考试吗？'
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids: [record.id],
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                },
              },
              recordChangeParams: ({ record, rows }) => {
                let is = record.status === 1;
                return { disabled: is, hidden: is }
              },
            },
            {
              key: 'close',
              custom: true,
              params: { children: '关闭' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'close'
                },
                formatParams: (rows, record, filters, callback) => {
                  const content = '您确定要关闭该考试吗？'
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids: [record.id],
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let is = record.status !== 1;
                return { disabled: is, hidden: is }
              },
            },
            {
              key: 'delete',
              custom: true,
              params: { children: '删除' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'delExam'
                },
                formatParams: (rows, record, filters, callback) => {
                  const content = '您确定要删除该考试吗？'
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        id: record.id,
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let is = record.status !== 0;
                return { disabled: is, hidden: is }
              },
            },
            {
              key: 'update',
              custom: true,
              params: { children: '编辑' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/online/exam/examDetailUpd'
                }
              }
            },
            {
              key: 'look',
              custom: true,
              params: { children: '查看' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/online/exam/examLook'
                }
              }
            },
            {
              key: 'examPreview',
              custom: true,
              params: { children: '考试预览' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/online/exam/examInfo'
                }
              }
            },
            {
              key: 'advancedSet',
              custom: true,
              params: { children: '高级设置' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalParams: {
                    title: '高级设置',
                    bordered: true,
                    footer: null,
                    destroyOnClose: true,
                    diy: (e) => {
                      return <>
                        <HighSet data={{ record: e.record, bizType: 1 }}
                          changeModal={e.changeModal}
                        />
                      </>
                    },
                    width: 950
                  },
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let disabled = false
                if (record && record['status'] === 2) {
                  disabled = true
                }
                return { disabled }
              }
            },
            {
              key: 'downloadExamRank',
              custom: true,
              params: { children: '下载考试排名' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalParams: {
                    title: '考试排名',
                    bordered: true,
                    footer: null,
                    destroyOnClose: true,
                    diy: ({ record }) => {
                      let url = `${constants.env.nev_env[process.env.REACT_APP_ENV]}/#/pages/manager-exam-ranking/index?id=${record.id}&title=${record.title}`
                      return <iframe src={url} width="452" height="750" frameBorder="no" />
                    },
                    width: 500
                  },
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let disabled = false
                if (record ?.['categoryType'] !== '天天学练') {
                  disabled = true
                }
                return { disabled }
              }
            },
            {
              key: 'authSetting',
              custom: true,
              params: { children: '受众设置' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalParams: {
                    title: '受众设置',
                    bordered: true,
                    footer: null,
                    destroyOnClose: true,
                    diy: (e) => {
                      return <>
                        <WizDataAuthSelect 
                          value = {e.record.targetScope}
                          onSubmit ={(values)=>{self._saveAuth(values,e.changeModal)}} 
                          bizType = {1}
                          bizId = {e.record.id}
                          changeModal={e.changeModal}
                        />
                      </>
                    },
                    width: 950
                  },
                }
              },
              recordChangeParams: ({ record, rows }) => {
                return true
              }
            },
          ],
        modalFormProps:
          {}
        ,
        dataTableProps: {
          rowKey: 'id',
          selectType:
            'checkbox',
          isScroll:
            true,
          loading:
            false
        }
        ,
        showAuth: [{
          title: '考试受众',
          dataIndex: 'targetScope',
        }, {
          title: '管理权限',
          text: '查看权限',
          dataIndex: 'managerTargetScope',
        }]
      }
    }
  }
};



let reduxTemplateConfig = (args) => {
  const apis = {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    publish: {
      path: `${componentName}/publish`,
      payload: {
        key: `${componentName}@publish`,
        apiParams: {}
      }
    },
    close: {
      path: `${componentName}/close`,
      payload: {
        key: `${componentName}@close`,
        apiParams: {}
      }
    },
    delExam: {
      path: `${componentName}/delExam`,
      payload: {
        key: `${componentName}@delExam`,
        apiParams: {}
      }
    },
    changeExamFaceAuth: {
      path: `${componentName}/changeExamFaceAuth`,
      payload: {
        key: `${componentName}@changeExamFaceAuth`,
        apiParams: {}
      }
    },
  }

  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
